import { chainSteps, chainIntro } from "@/mocks/editorial";

export default function ChainSection() {
  return (
    <section id="chain" className="scroll-mt-24 bg-background-50 py-12 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          {/* 左：导语与强调块 */}
          <div className="lg:col-span-5">
            <p className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium tracking-wide text-secondary-800">
              <span className="inline-block h-1.5 w-1.5 rounded-full bg-accent-500"></span>
              连锁反应 · 扩散机理
            </p>
            <h2 className="mt-4 font-heading text-2xl font-semibold leading-snug text-foreground-950 md:text-[2rem] md:leading-[1.3]">
              牵一发，如何动全身？
            </h2>
            <p className="mt-4 text-[15px] leading-relaxed text-foreground-600">
              {chainIntro}
            </p>

            <div className="mt-8 rounded-2xl bg-foreground-950 p-6 text-background-50">
              <p className="font-heading text-xl font-semibold">
                一句话观察公式
              </p>
              <p className="mt-3 text-sm leading-relaxed text-background-100/90">
                爆发强度 = 信息裂变速度 × 情绪共鸣深度 × 放大节点数量。
                <br />
                任一项归零，热度都会迅速哑火。
              </p>
              <a
                href="#lifecycle"
                className="mt-5 inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-accent-300 hover:text-accent-200"
              >
                看热度生命周期
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          {/* 右：四阶段步骤 */}
          <div className="lg:col-span-7">
            <ol className="space-y-4">
              {chainSteps.map((s, i) => (
                <li
                  key={s.title}
                  className="relative flex gap-5 rounded-2xl border border-background-200 bg-background-100/60 p-5"
                >
                  <div className="flex flex-col items-center">
                    <span className="grid h-12 w-12 shrink-0 place-items-center rounded-full bg-primary-500 font-heading text-lg font-semibold text-background-50">
                      {i + 1}
                    </span>
                    {i < chainSteps.length - 1 && (
                      <span className="mt-1 w-px flex-1 bg-gradient-to-b from-primary-300 to-background-300"></span>
                    )}
                  </div>
                  <div className="flex-1">
                    <h3 className="font-heading text-lg font-semibold text-foreground-950">
                      {s.title}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                      {s.body}
                    </p>
                  </div>
                  <i className="ri-arrow-down-line hidden text-background-300 sm:block"></i>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}